import React, { useEffect, useState } from "react";
import "../assets/css/home.css";

export default function TopButton() {
    const [showTop, setShowTop] = useState(false);
    useEffect(() => {
        const onScroll = () => {
            setShowTop(window.scrollY > 300);
        };

        window.addEventListener("scroll", onScroll);
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollToTop = (e) => {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            {showTop && (
                <a
                    href="#top"
                    className="go-top-icon"
                    onClick={scrollToTop}
                    aria-label="Go to top"
                >
                    <i className="bx bx-up-arrow-alt"></i>
                </a>
            )}
        </>
    );
}